/**
 * StreamWebhookEventListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StreamWebhookEventListReq
 */
export interface StreamWebhookEventListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 事件类型 */
  event_type?: string
  /** 频道类型 */
  channel_type?: string
  /** 处理状态 */
  process_status?: string
  /** 频道ID */
  channel_id?: string
  /** 消息ID */
  message_id?: string
  /** 触发用户ID */
  user_id?: any
  /** Webhook ID */
  webhook_id?: string
  /** 事件类型列表 */
  event_type__in?: string[]
  /** 频道类型列表 */
  channel_type__in?: string[]
  /** 处理状态列表 */
  process_status__in?: string[]
  /** 频道CID包含 */
  cid__like?: string
  /** 错误信息包含 */
  process_error__like?: string
  /** 接收时间范围 */
  received_at__range?: any
  /** 处理时间范围 */
  processed_at__range?: any
  /** 事件时间范围 */
  event_created_at__range?: any
}

/**
 * StreamWebhookEventListReq Schema
 */
export const StreamWebhookEventListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    event_type: {
      description: '事件类型',
      format: 'string',
      type: 'string',
      label: '事件类型',
    },
    channel_type: {
      description: '频道类型',
      format: 'string',
      type: 'string',
      label: '频道类型',
    },
    process_status: {
      description: '处理状态',
      format: 'cons.StreamWebhookProcessStatus',
      type: 'string',
      label: '处理状态',
    },
    channel_id: {
      description: '频道ID',
      format: 'string',
      type: 'string',
      label: '频道ID',
    },
    message_id: {
      description: '消息ID',
      format: 'string',
      type: 'string',
      label: '消息ID',
    },
    user_id: {
      description: '触发用户ID',
      format: 'string',
      type: 'user',
      label: '触发用户ID',
    },
    webhook_id: {
      description: 'Webhook ID',
      format: 'string',
      type: 'string',
      label: 'Webhook',
    },
    event_type__in: {
      description: '事件类型列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '事件类型列表',
    },
    channel_type__in: {
      description: '频道类型列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '频道类型列表',
    },
    process_status__in: {
      description: '处理状态列表',
      format: '[]cons.StreamWebhookProcessStatus',
      items: {
        format: 'cons.StreamWebhookProcessStatus',
        type: 'string',
      },
      type: 'array',
      label: '处理状态列表',
    },
    cid__like: {
      description: '频道CID包含',
      format: 'string',
      type: 'string',
      label: '频道CID包含',
    },
    process_error__like: {
      description: '错误信息包含',
      format: 'string',
      type: 'string',
      label: '错误信息包含',
    },
    received_at__range: {
      description: '接收时间范围',
      format: '[]string',
      type: 'datetime',
      label: '接收时间范围',
    },
    processed_at__range: {
      description: '处理时间范围',
      format: '[]string',
      type: 'datetime',
      label: '处理时间范围',
    },
    event_created_at__range: {
      description: '事件时间范围',
      format: '[]string',
      type: 'datetime',
      label: '事件时间范围',
    },
  },
  type: 'object',
}
